import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { BrandColors } from '../../constants';

export const AccountSelectionPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContainer: {
      minHeight: 'inherit',
      background: `${BrandColors.grey90}`,
      padding: '0 2rem',
    },
    container: {
      marginLeft: 'auto',
      marginRight: 'auto',
      minHeight: 'inherit',
      [theme.breakpoints.up('lg')]: {
        maxWidth: '500px',
      },
      [theme.breakpoints.up('xl')]: {
        maxWidth: '700px',
      },
    },
    grid: {
      width: 'inherit',
      color: 'inherit',
    },
    title: {
      fontSize: 18,
      lineHeight: '30px',
      fontWeight: 700,
      color: `${BrandColors.grey30}`,
      margin: '2% 0px',
    },
    subtitle: {
      fontSize: 18,
      lineHeight: '34px',
      fontWeight: 400,
      color: `${BrandColors.grey30}`,
      margin: '2% 0px',
    },
    list: {
      border: 'none',
      background: 'none',
      boxShadow: 'none',
    },
    item: {
      margin: '2% 0px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 62,
      color: BrandColors.grey30,
      fontWeight: 700,
      textAlign: 'center',
      fontSize: 18,
      backgroundColor: theme.palette.background.default,
      boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.08)',
      borderRadius: 8,
      '&:hover': {
        backgroundColor: theme.palette.background.default,
      },
    },
    selectedItem: {
      '&.Mui-selected, &.Mui-selected:hover': {
        color: BrandColors.white,
        backgroundColor: BrandColors.link,
      },
    },
    divider: {
      marginTop: '2.5rem',
      marginBottom: '1.25rem',
    },
    footer: {
      paddingBottom: 80,
    },
    select: {
      width: '70%',
      textAlign: 'center',
      border: `1px solid ${BrandColors.grey80}`,
      borderRadius: 6,
    },
    selectSelect: {
      '&:focus': {
        borderRadius: 6,
      },
    },
    selectIcon: {
      color: theme.palette.primary.main,
    },
    menuList: {
      maxHeight: 'none',
    },
    continueButton: {
      width: '100%',
      marginTop: '1rem',

      [theme.breakpoints.up('sm')]: {
        marginTop: '0',
        width: 'auto',
      },
    },
  }),
);
